import DialogBox from "components/shared/modal/DialogBox";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useState } from "react";
import CustomTab from "components/shared/Tab/CustomTab";
import BookingDetails from "./BookingDetails";
import { BlackButtonComponent } from "components/index";

interface SlotDetailsModalProps {
  open: boolean;
  handleClose: () => void;
  data: any;
  showDiscount: boolean;
  onMarkAsNoted?: (row: any) => void;
}

const BookingModal = (props: SlotDetailsModalProps) => {
  const { open, handleClose, data, showDiscount, onMarkAsNoted } = props;
  const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {
      label: "Booking details",
      content: <BookingDetails data={data} showDiscount={showDiscount} />,
    },
  ];

  return (
    <DialogBox open={open} onClose={handleClose}>
      <Box p={4}>
        <Box display={"flex"} justifyContent={"flex-start"} alignItems="center" gap={1}>
          <Typography variant="h6" fontWeight="600" color="black" flexGrow={1}>
            Booking details
          </Typography>
          <IconButton
            sx={{ color: "black" }}
            aria-label="close"
            size="small"
            onClick={handleClose}
          >
            <Tooltip title="Close">
              <Close />
            </Tooltip>
          </IconButton>
        </Box>
        <CustomTab
          tabs={tabs}
          activeTab={activeTab}
          onChange={(index) => setActiveTab(index)}
          sx={{
            mt: 2,
            borderBottom: "1px solid #e0e0e0",
            maxHeight: "500px",
          }}
        />
        <Box mt={2} display="flex" justifyContent="flex-end">
        {onMarkAsNoted && (
          // <IconTextButton sx={{ bgcolor:'#87a5d6', color: 'white' }} label="Mark As Noted" onClick={() => onMarkAsNoted(data)} Icon={<FlagOutlined />} tooltip="Mark As Noted" /> //add bg color blue gray white text
          <BlackButtonComponent sx={{backgroundColor:'#08253c'}} btnText="Mark As Noted" onClick={() => onMarkAsNoted(data)}  />
        )}
        </Box>
      </Box>
    </DialogBox>
  );
};
export default BookingModal;
